// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { BackView } from '@holmescorp/backview';
import { convertToBoolean } from '@holmescorp/common';
import { createNlsMiddleware, lccstate, load_topic, userstate } from '@holmescorp/lcc-state';
import { TopicAttrs, TopicItem } from '@holmescorp/lcc-state/interfaces';

import css from '../css/topicgroup.m.css';
import { TopicProperties } from '../interfaces';
import { TopicRef } from './topic-ref';

interface TopicGroupIcache {
	comconn: TopicItem;
	comconnrel: string;
	compconnOpen: boolean;
}

const nls = createNlsMiddleware('ditabook');
const nls_settings = createNlsMiddleware('settings');
const icache = createICacheMiddleware<TopicGroupIcache>();
const factory = create({ icache, theme, nls, nls_settings, lccstate, userstate }).properties<TopicProperties>();

export const TopicGroup = factory(({ properties, middleware: { icache, theme, nls, nls_settings, lccstate } }) => {
	const {
		isPlaceholder,
		messages: {
			// quiz: quizText = '',
			// flashcards: flashcardText = '',
			completed = '',
			incompleted = '',
			// competency_connection: ccTitle
			reading = '[ditabook] reading',
			topicgroup_show_shortdesc = 'true'
		}
	} = nls();
	const {
		messages: { association = '[settings] association' }
	} = nls_settings();
	if (isPlaceholder) {
		return null;
	}

	const show_shortdec = convertToBoolean(topicgroup_show_shortdesc);

	const {
		topic: { attributes = {} as TopicAttrs, children = [] }
	} = properties();
	const { key, title, rel = '' } = attributes;

	// Set page title
	const setPageTitle = () => {
		const { get, path } = lccstate;
		const product = get(path('product'));
		document.title = `${reading} - ${title} (${association} ${product.toLocaleUpperCase()} )`;
	};

	const themeCss = theme.classes(css);

	const deck = (): DNode => {
		const { topic } = properties();
		return w('Generator', { skipTitle: true, topic });
	};

	const competency_connection = (rel: string): DNode => {
		icache.set('comconnrel', rel);
		const { get, path } = lccstate;
		const bookversion = get(path('bookversion'));
		const lang = window.hcstatic.portal_language || 'en';
		const comconn = icache.getOrSet('comconn', async () => {
			const val: TopicItem = (await load_topic(rel, bookversion, lang)) as any as TopicItem;
			return val;
		});

		const { children } = comconn ? comconn.topic : { children: undefined };
		const body = children ? children.filter((v) => 'body' in v) : [];
		const hasBody = body.length > 0;

		return v('div', { key: 'compconn', xqa: 'topicgroup compconn', classes: [themeCss.competencyConnection] }, [
			hasBody ? w('Generator', { skipTitle: true, renderBody: true, compconn: true, topic: comconn }) : null
		]);
	};

	const legend = (): DNode => {
		return v('div', { classes: [themeCss.legend] }, [
			v('span', { ...formatAriaProperties({ disabled: 'true' }), classes: [themeCss.complete] }, [
				v('i', { classes: ['fa', 'fa-lg', 'fa-check-square'] })
			]),
			v('span', { classes: [themeCss.legendText] }, [completed]),
			v('span', { ...formatAriaProperties({ disabled: 'true' }), classes: [themeCss.incomplete] }, [
				v('i', { classes: ['far', 'fa-lg', 'fa-square'] })
			]),
			v('span', { classes: [themeCss.legendText] }, [incompleted])
		]);
	};

	const kids = children
		.filter((val) => !('shortdesc' in val))
		.map((val) => {
			const { attributes, children } = val.topicref;
			return w(TopicRef, { topic: { attributes, children } });
		});

	setPageTitle();
	const groupTitle = `${rel}-title`;
	return v('div', { key: `tgroot-${key}`, classes: [themeCss.root] }, [
		v(
			'div',
			{
				id: groupTitle,
				xqa: `topicgroup grouphead`,
				classes: [themeCss.grouphead]
			},
			[
				v('div', { classes: [themeCss.titleBlock] }, [
					v('h1', { classes: [themeCss.title] }, [title]),
					v('div', {}),
					w(BackView, {})
				])
			]
		),
		v(
			'div',
			{
				role: 'group',
				'aria-labelledby': groupTitle,
				key,
				xqa: `topicgroup ${key}`,
				classes: [themeCss.group]
			},
			[show_shortdec ? deck() : null, competency_connection(rel), legend(), ...kids]
		),
		v('div', { xqa: `topicgroup actions`, classes: [themeCss.actions] }),
		w('TocSlidePane', {})
	]);
});
